import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';
import { sampleStadiums } from '../seedData';
import { Upload, CheckCircle, AlertCircle } from 'lucide-react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const SeedDatabase = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const seedDatabase = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Add each stadium to Firebase
      for (const stadium of sampleStadiums) {
        await setDoc(doc(db, 'stadiums', stadium.id), stadium);
        console.log(`Added ${stadium.name}`);
      }

      setSuccess(true);
      toast.success(t('seeddatabase.seeded'));
    } catch (err) {
      console.error('Error seeding database:', err);
      setError(err.message);
      toast.error(t('seeddatabase.errorSeed', { message: err.message }));
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Seed Database</h2>
        <p className="text-gray-600 mb-6">
          This will add {sampleStadiums.length} sample stadiums to your database for testing.
        </p>

        <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 mb-6">
          <h3 className="font-semibold text-blue-900 mb-2">Stadiums to add:</h3>
          <ul className="text-sm text-blue-800 space-y-1">
            {sampleStadiums.map(stadium => (
              <li key={stadium.id}>✓ {stadium.name} ({stadium.sports.length} sports)</li>
            ))}
          </ul>
        </div>

        {success && (
          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 mb-4 flex items-center gap-3">
            <CheckCircle className="text-green-600" size={24} />
            <span className="text-green-800 font-semibold">Database seeded successfully!</span>
          </div>
        )}

        {error && (
          <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 mb-4 flex items-center gap-3">
            <AlertCircle className="text-red-600" size={24} />
            <span className="text-red-800 font-semibold">{error}</span>
          </div>
        )}

        <button
          onClick={seedDatabase}
          disabled={loading}
          className="w-full flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-4 rounded-xl font-bold hover:from-blue-700 hover:to-purple-700 transition disabled:opacity-50"
        >
          <Upload size={20} />
          {loading ? 'Seeding Database...' : 'Seed Database Now'}
        </button>

        <p className="text-xs text-gray-500 mt-4 text-center">
          ⚠️ Run this once. Check Firebase Console after to verify.
        </p>
      </div>
    </div>
  );
};

export default SeedDatabase;